import React, { useEffect } from 'react'
import './Question.css'
import { withRouter } from 'react-router'
import { UPDATE_COMPLETION } from '../../constants/actionTypes'
import { connect } from 'react-redux'
import QuestionSection from '../QuestionSection/QuestionSection'

const mapStateToProps = (state) => {
    return {
        testData: state.testpanel,
    }
}

const mapDispatchToProps = (dispatch) => ({
    setCompletion: (payload) => dispatch({ type: UPDATE_COMPLETION, payload }),
})

const Question = (props) => {
    useEffect(() => {
        let count = 0
        let total = 0
        let completion
        let d = [...props.testData.questionset]
        if ((d !== null) & (d != undefined)) {
            for (let i = 0; i < d.length; i++) {
                for (let j = 0; j < d[i].questionList.length; j++) {
                    if (d[i].questionList[j].question.isAnswered) {
                        count++
                    }
                    total++
                }
            }
            completion = ((count / total) * 100).toFixed(0)
            props.setCompletion(completion)
        }
    }, [props.testData])
    return props.question.map((data, index) => {
        return index === props.active ? (
            <QuestionSection
                key={index + 'question_section'}
                isPreview={props.isPreview}
                tabSwitchCount={props.tabSwitchCount}
                subject={data.subject}
                data={data}
                index={index}
                active={props.active}
                setActive={props.setActive}
                setDisconnectTime={props.setDisconnectTime}
                sectionCount={props.question.length}
                islast={props.question.length === index + 1 ? true : false}
                handleGTagLogs={props.handleGTagLogs}
            />
        ) : (
            ''
        )
    })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Question))
